import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@mui/styles";
import {
  Dialog,
} from "@mui/material";
import { userInfoContext } from "../../context/userInfoContext";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import * as Routes from "../../Routes";
import {
  CloseIconWrapper,
  Icon,
  IconCard,
  IconWrapper,
  Logo,
  LogoWrapper,
  MenuIconWrapper,
  MobileIcon,
  MobileIconWrapper,
  MobileLogoWrapper,
  MobileView,
  Root,
  Text,
  TextWraper,
  } from "../StyledComponents/MenuListStyledComponents";
  import { WalletDetailsPopup } from "../WalletComponents/WalletDetailsPopup";
  import { Modal } from "@mui/material";
  import styled from "styled-components";
  import { init, balanceOf, getBalance } from "../../config/provider";
  import { ethers } from "ethers";
  import axios from "axios";
  import environmentVariables from "../../config/environmentVariables";
  import { userBalanceContext } from "../../context/userBalanceContext";
  import { buyTokenPopUpContext } from "../../context/buyTokenPopUpContext";
  import LoginLoader from '../../Components/LoginLoader/LoginLoader'
import { toast } from "react-toastify";
import { useSocket } from "../../context/socketContext";
  const MALogo =   `${environmentVariables?.cdnUrl}ms-logo.png`
  const HomeIcon = `${environmentVariables?.cdnUrl}home.png`
  const FarmIcon = `${environmentVariables?.cdnUrl}farm.png`
  const PoolIcon = `${environmentVariables?.cdnUrl}pool.png`
  const NftMarketing = `${environmentVariables?.cdnUrl}nft-marketing.png`;
  const Wallet = `${environmentVariables?.cdnUrl}wallet.png`;
  
const useStyles = makeStyles((theme) => ({
  customButton: {
    padding: "30px",
    backgroundColor: "#2a2a2a",
    border: "1px solid #484848",
    borderRadius: "10px",
    color: "#fff",
    minWidth: "300px",
    "@media (max-width: 768px)": {
      minWidth: "360px",
    },
    "@media (max-width: 600px)": {
      maxWidth: "220px",
      minWidth: "350px",
      padding: "40px 30px",
      backgroundColortransparent: true,
    },
  },
}));

const ComingSoonTag = styled.span`
  margin-left: 8px;
  padding: 2px 8px;
  font-size: 8px;
  font-weight: 600;
  text-transform: uppercase;
  border-radius: 12px;
  letter-spacing: 0.5px;

  background: rgb(32 55 54);
  color: #87fdfd;
  border: 1px solid rgb(129 241 241);

  cursor: default;
  user-select: none;

  white-space: nowrap;        /* ✅ THIS FIXES THE ISSUE */
  display: inline-flex;       /* keeps it aligned nicely */
  align-items: center;
`;



const ProfileIcon = styled.div`
  font-size: 30px;
`;
const Span = styled.span`
  padding: 0 10px;
`;
const ButtonCancel = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -15px;
  right: -20px;
  background-color: #b3b3b3;
  border-radius: 50px;
  outline: none;
  border: none;
  font-size: 20px;
  /* font-weight: 600; */
  padding: 20px;
  margin: 0;
  cursor: pointer;
  color: #000;
  width: 45px;
  height: 45px;
  transition: 1s;
  @media (max-width: 768px) {
    margin: 5px 0;
    top: -25px;
    right: -15px;
  }
  @media (max-width: 600px) {
    top: -30px;
    ${'' /* right: 85px; */}
  }
  /* &:hover {
    background: linear-gradient(45deg, #fff, #d3d3d3);
    color: #151a1c;
  } */
`;
const NftNameConfirm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  padding-top: 20px;
  border-bottom: 1px solid #484848;
  border-top: 1px solid #484848;
  justify-content: center;
  ${(p) => {
    p.ConfirmPopup &&
      `
   justify-content: flex-start;
  `;
  }}
`;
const NftNameConfirmHead = styled.div`
  font-size: 32px;
  font-weight: 500;
  // text-align: center;
`;
const BuyPop = styled.div`
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 16px;
  font-weight: 600;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: capitalize;
  background-color: #171e22;
  padding: 25px 20px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  border: 1px solid #31393c;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 35px;
  width: 170px;
  margin-top: 20px;
  cursor: pointer;
  &:hover {
  }
`;
const NftNameConfirmSubHead = styled.div`
  font-size: 16px;
  color: #bbb;
  text-transform: capitalize;
  padding-top: 10px;
  padding-bottom: 15px;
`;
const DropDownSection = styled.div`
  position: absolute;
  left: 70px;
  box-shadow: none;
  top: 45px;
  width: 100%;
  cursor: pointer;
  color: #fff;

  @media (max-width: 768px) {
      top: 55px;
      height: 180px;
      overflow-y: scroll;
      scroll-behavior: smooth;
       width: 60%;

         &::-webkit-scrollbar {
             width: 8px !important;
          }

          &::-webkit-scrollbar-thumb {
            background-color: #888 !important;
            border-radius: 4px !important;
          }

          &::-webkit-scrollbar-thumb:hover {
            background-color: #555 !important;
          }
          }
 
`;

const List = styled.div`
  font-size: 15px;
  height: 45px;
  display: flex;
  align-items: center;
  padding: 20px;

  @media (max-width: 768px) {
    color: #d5cdcd;
    padding: 0;
    height: 35px;
    margin: 20px 0;
  }
  @media (max-width: 1024px) {
    color: #d5cdcd;
    padding: 0;
    height: 35px;
    margin: 20px 0;
  }
`;
const DialogStyledUpdate = styled(Dialog)``;
const LeftsideBar = ({
  callFun,
  showNavigation,
  setShowNavigation,
  allContractDetails,
  setAllContractDetails,
  show,
  walletPopUpOpen,
  setWalletPopUpOpen,
  setShow,
}) => {

  const classes=useStyles();
  let navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const { isBuyOpen } = useContext(buyTokenPopUpContext);
  const [balanceLoading,setBalanceLoading] = useState(false)
  const {userAccInfo, setUserAccInfo}=useContext(userInfoContext)
  const [buyTokenLoginPopUp,setBuyTokenLoginPopUp]=useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {setOpen(false);setWalletPopUpOpen(null)}
  const [navLink, setNavLink] = useState(location.pathname);
  const [dropdown, setDropdown] = useState(false);
  const socket = useSocket();
  const { userBalance, setUserBalance } = useContext(userBalanceContext);

  const setUserToken=(res)=>{
    if(res?.idToken){
      let data={
        userName:res?.userInfo?.email||res?.userInfo?.name||res?.userInfo?.verifierId||'metamask',
        address:res?.address
      }
      let config={
        method:"post",
        url:`${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get/token`,
        headers:{
          authorization:`Bearer ${res?.idToken?.idToken}`
        },
        data:data
      }
      axios.request(config).then(respnse=>{
        console.log(respnse,';;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;s')
      }).catch( err=>{
        console.log(err);
        localStorage.clear();
      allContractDetails?.logout();
      setAllContractDetails(null);
      setUserBalance({
        MLDBalance: 0,
        MLDBalanceDec:0,
        MLDUSD:0,
        MLD: 0,
        USDT:0,
        USDTBalance: 0,
        LORDBalance: 0,
        LORDUSD:0,
        LORD: 0,
        MATICBalance: 0,
        MATIC: 0,
        MATICUSD:0,
      });
        // toast.error(err?.response?.data?.message||err?.message)
      })
    }else{
      // toast.error("id token is required")
    }

  }


  const handleLogin=()=>{
    try{
      setBalanceLoading(true);
      setBuyTokenLoginPopUp(false)
      init().then(res=>{
        getInformation(res);
        setAllContractDetails(res);
        setUserToken(res)
        console.log(res,';;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;')
        handleOpen();
        setBalanceLoading(false)
      }).catch(err=>{
        setBalanceLoading(false)
        console.log(err)  
      })
    }catch(err){
      setBalanceLoading(false)
      console.log(err);
    }
  }
   
  const setDataOfContract = async () => {
    const address = allContractDetails?.address;

    const mldBal = await balanceOf(
      allContractDetails?.mldTokenContract,
      address
    );
    const lordBal = await balanceOf(
      allContractDetails?.lordTokenContract,
      address
    );
    const usdtBal = await balanceOf(
      allContractDetails?.usdtTokenContract,
      address
    );
    const maticBal = await getBalance(allContractDetails?.provider, address);

    // setUserBalance({
    //   MLDBalance: parseInt(mldBal),
    //   LORDBalance: parseInt(lordBal),
    //   USDTBalance: parseInt(usdtBal),
    //   MLD: ethers.formatEther(mldBal),
    //   LORD: ethers.formatEther(lordBal),
    //   MATICBalance: parseInt(maticBal),
    //   MATIC: ethers.formatEther(maticBal),
    //   USDT: ethers.formatEther(usdtBal),
    // });
  };
  useEffect(() => {
    if (isBuyOpen) {
      handleOpen();
    }
  }, [isBuyOpen]);
  useEffect(() => {
    if (callFun) {
      setDataOfContract();
    }
  }, [callFun]);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const action = params.get("action");
    // const token=params.get("token");
    // console.log(action,token,'//////////////////////////////////////////////////////////////////');
    if (action == "buy"||action=="swap") {
      // setOpen(true)
      localStorage.clear();
      allContractDetails?.logout();
      setBuyTokenLoginPopUp(true);
    }
  }, []);
  useEffect(()=>{
    
    if(walletPopUpOpen=="MLD"){
      setOpen(true)
    }else if(walletPopUpOpen=="MATIC"){
setOpen(true)
    }else if(walletPopUpOpen=="LORD"){
setOpen(true)
    }else if(walletPopUpOpen=="USDT"){
 setOpen(true)
    }
  },[walletPopUpOpen])
  useEffect(() => {
    if (allContractDetails && allContractDetails?.address) {
      setDataOfContract();
      getUserBalance(allContractDetails?.address);
    }
  }, [allContractDetails]);
  
  useEffect(()=>{
    if(allContractDetails?.address){
      socket.on("register",allContractDetails?.address.toLowerCase())

      socket.on("notifications",(data)=>{
      getUserBalance(allContractDetails?.address)
    })
    socket.on("balance-update",()=>{
      getUserBalance(allContractDetails?.address)
    })
    }
    return ()=>{
      socket.off("notifications")
    }
  },[socket,allContractDetails])




  // useEffect(() => {
  //   if (allContractDetails) {
  //     socket.emit("join_room", allContractDetails?.address);
  //     socket.on("receive_mld", async (data) => {
  //       // Swal.fire(
  //       //   `Received ${data?.currency}`,
  //       //   `Received ${data?.amount} ${data?.currency} from ${data?.from}`,
  //       //   "success"
  //       // );
  //       getUserBalance(allContractDetails?.address);
  //     });
  //   }
  // }, [socket, allContractDetails]);

  // const connectWallet = async () => {
  //   init().then(async (data) => {
  //     setAllContractDetails(data)
  //     const address = data.address;

  //     const mldBal = await balanceOf(data.mldTokenContract, address)
  //     const lordBal = await balanceOf(data.lordTokenContract, address)
  //     const maticBal = await getBalance(data.provider, address)

  //     setUserBalance({
  //       MLDBalance: parseInt(mldBal),
  //       LORDBalance: parseInt(lordBal),
  //       MLD: ethers.formatEther(mldBal),
  //       LORD: ethers.formatEther(lordBal),
  //       MATICBalance: parseInt(maticBal),
  //       MATIC: ethers.formatEther(maticBal),
  //     })
  //   }).catch((err) => {
  //     console.log('err', err)
  //   })
  // }
  // const logoutWallet = async () => {
  //   await allContractDetails?.logout().then(async (data) => {
  //     console.log('logout data', data)
  //     clearData()
  //     setAllContractDetails({})
  //   }).catch((err) => {
  //     console.log('err', err)
  //   })
  // }
  const getUserBalance = (address) => {
    setUserBalance((prev) => ({
      ...prev,
      loading: true,
    }));
    axios
      .get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getuserbalance/${address}`,
        {headers:{authorization:`Bearer ${userAccInfo}`}}
      )
      .then((res) => {
        // console.log(res.data.data);
        if (res?.data?.success == true) 
          setUserBalance({
            MLDBalance: res?.data?.data?.MLDBalance || 0,
            LORDBalance: res?.data?.data?.LORDBalance || 0,
            MATICBalance: res?.data?.data?.MATICBalance || 0,
            USDTBalance: res?.data?.data?.USDTBalance || 0,
            MLD: res?.data?.data?.MLD || 0,
            LORD: res?.data?.data?.LORD || 0,
            MATIC: res?.data?.data?.MATIC || 0,
            USDT: res?.data?.data?.USDT || 0,
            LORDUSD: res?.data?.data?.LORDUSD || 0,
            MATICUSD: res?.data?.data?.MATICUSD || 0,
            MLDUSD: res?.data?.data?.MLDUSD || 0,
            MLDBalanceDec: res?.data?.data?.MLDBalanceDec || 0,
            LORDBalance: res?.data?.data?.LORDBalance || 0,
            loading: false,
          });
        else
          setUserBalance({
            MLDBalance: 0,
            LORDBalance: 0,
            MATICBalance: 0,
            USDTBalance: 0,
            MLD: 0,
            LORD: 0,
            MATIC: 0,
            USDT: 0,
            LORDUSD: 0,
            MATICUSD: 0,
            MLDUSD: 0,
            MLDBalanceDec: 0,
            LORDBalance: 0,
            loading: false,
          });
      })
      .catch((err) => console.log(err));
  };
  // const clearData = () => {
  //   setUserBalance({
  //     MLDBalance: 0,
  //     LORDBalance: 0,
  //     MLD: 0,
  //     LORD: 0,
  //     MATICBalance: 0,
  //     MATIC: 0,
  //   });
  // };
  const getInformation = async (data) => {
    // await clearData(); 

    const address = data.address;

    const mldBal = data.mldBal;
    const lordBal = data.lordBal;
    const maticBal = data.maticBal;
    const usdtBal = data.usdtBal;
    console.log(data,'dataaftergetingormationinthecomonet')
    setUserBalance({
      MLDBalance: parseInt(mldBal),
      LORDBalance: parseInt(lordBal),
      USDTBalance: parseInt(usdtBal),
      MLD: ethers.formatEther(mldBal),
      MLDBalanceDec: ethers.formatUnits(mldBal,18),
      LORD: ethers.formatEther(lordBal),
      USDT: ethers.formatUnits(usdtBal,6),
      MATICBalance: parseInt(maticBal),
      MATIC: ethers.formatEther(maticBal),
      loading:false,
    });
  };
  return (
    <>
      {
        <MenuIconWrapper
          onClick={(e) => {
            e.stopPropagation();
            setShowNavigation(!showNavigation);
          }}
          style={{ zIndex: "9" }}
        >
          <i class="fa-solid fa-bars"></i>
        </MenuIconWrapper>
      }
      <Root>
        <LogoWrapper
          onClick={() => {
            navigate("/");
          }}
        >
          <Logo
            src={MALogo}
            width="60px"
            height="56px"
            top="sm"
            bottom="sm"
            cursor="pointer"
          />
        </LogoWrapper>

        <IconCard wallett onClick={handleOpen}>
          <IconWrapper>
            <ProfileIcon>
              <Icon src={Wallet} width="24px" height="24px" />
            </ProfileIcon>
          </IconWrapper>
          <Text wallettext>Wallet</Text>
        </IconCard>

        <IconCard
          selected={location.pathname === "/"}
          top="xs"
          bottom="xxs"
          onClick={() => {
            navigate("/");
            setNavLink("/");
          }}
        >
          <IconWrapper>
            <Icon src={HomeIcon} width="20px" height="20px" />
          </IconWrapper>
          <Text>Dashboard</Text>
        </IconCard>

        <IconCard
          selected={
            location.pathname === "/nftMarket" ||
            location.pathname === "/trendingnfts" ||
            location.pathname === "/auctionnfts" ||
            location.pathname === "/mynfts" ||
            location.pathname ===
              "/nftcategories/0x8fc3dec6148a9924870f205617c9c26b3010243e"
          }
          onClick={() => {
            navigate(`${Routes.NFTMARKET}`);
            setNavLink("/nftMarket");
          }}
        >
          <IconWrapper>
            <Icon src={NftMarketing} width="24px" height="20px" />
          </IconWrapper>
          <Text>Marketplace</Text>
        </IconCard>
        <IconCard
          selected={location.pathname === "/pool"}
          onClick={() => {
            navigate(`${Routes.POOL}`);
            setNavLink("/pool");
          }}
        >
          <IconWrapper>
            <Icon src={PoolIcon} width="24px" height="24px" />
          </IconWrapper>
          <Text>NFT Staking</Text>
        </IconCard>
        <IconCard
          selected={location.pathname === "/stake"}
          onClick={() => {
            navigate(`${Routes.FARM}`);
            setNavLink("/stake");
          }}
        >
          <IconWrapper>
            <Icon src={FarmIcon} width="22px" height="22px" />
          </IconWrapper>
          <Text style={{whiteSpace:"nowrap"}}>$MLD Staking <ComingSoonTag>Coming Soon</ComingSoonTag></Text>
        </IconCard>
        {/* <IconCard  selected={location.pathname === '/metaDao'} 
      onClick={() => {
          navigate(`${Routes.METADAO}`);
          setNavLink('/metaDao');
        }}>
        <IconWrapper>
          <Icon src={MetaDaoIcon} width="24px" height="20px" />
        </IconWrapper>
        <Text>MetaDAO</Text>
      </IconCard> */}
        {/* <IconCard selected={location.pathname === '/stats'} onClick={() => {
          navigate(`${Routes.STATS}`);
          setNavLink('/stats');
        }}>
        <IconWrapper>
          <Icon src={StatsIcon} width="24px" height="24px" />
        </IconWrapper>
        <Text> Stats </Text>
      </IconCard> */}

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <WalletDetailsPopup
            getInformation={getInformation}
            setOpen={setOpen}
            walletPopUpOpen={walletPopUpOpen}
            userBalance={userBalance}
            getUserBalance={getUserBalance}
            allContractDetails={allContractDetails}
            setAllContractDetails={setAllContractDetails}
            showNavigation={showNavigation}
            setShowNavigation={setShowNavigation}
            handleClose={handleClose}
          />
        </Modal>
      </Root>
      {showNavigation && (
        <MobileView onClick={(e) => e.stopPropagation()}>
          <CloseIconWrapper
            onClick={() => {
              setShowNavigation(!showNavigation);
            }}
          >
            <i class="fa-solid fa-xmark"></i>
          </CloseIconWrapper>
          <MobileLogoWrapper
            selected={location.pathname === "/"}
            onClick={() => {
              navigate("/");
            }}
          >
            <Logo
              src={MALogo}
              width="60px"
              height="56px"
              top="sm"
              bottom="sm"
              cursor="pointer"
            />
          </MobileLogoWrapper>

          <IconCard wallett onClick={handleOpen}>
            <IconWrapper>
              <ProfileIcon>
                <Icon src={Wallet} width="24px" height="24px" />
              </ProfileIcon>
            </IconWrapper>
            <Text wallettext>Wallet</Text>
          </IconCard>

          <MobileIconWrapper
            selected={location.pathname === "/"}
            onClick={() => {
              navigate(`${Routes.HOME}`);
              setNavLink("/");
              setShowNavigation(!showNavigation);
            }}
          >
            <MobileIcon src={HomeIcon} width="22px" height="22px" />
            <TextWraper> Dashboard </TextWraper>
          </MobileIconWrapper>
          <MobileIconWrapper
            selected={location.pathname === "/pool"}
            onClick={() => {
              navigate(`${Routes.POOL}`);
              setNavLink("/");
              setShowNavigation(!showNavigation);
            }}
          >
            <MobileIcon src={PoolIcon} width="26px" height="26px" />{" "}
            <TextWraper>NFT Staking</TextWraper>
          </MobileIconWrapper>
          <MobileIconWrapper
            selected={location.pathname === "/stake"}
            onClick={() => {
              navigate(`${Routes.FARM}`);
              setNavLink("/stake");
              setShowNavigation(!showNavigation);
            }}
          >
            <MobileIcon src={FarmIcon} width="22px" height="22px" />
            <TextWraper>$MLD Staking <ComingSoonTag>Coming Soon</ComingSoonTag></TextWraper>
          </MobileIconWrapper>
          <MobileIconWrapper
            selected={location.pathname === "/nftMarket"}
            onClick={(e) => {
              e.stopPropagation();
              setDropdown(!dropdown);
            }}
          >
            <Icon src={NftMarketing} width="24px" height="20px" />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
              <TextWraper>Market</TextWraper>

              <Span>
              {dropdown ? <i class="fa-solid fa-angle-down"></i> : <i class="fa-solid fa-angle-right"></i>}
             
              </Span>
            </div>
            {dropdown && (
              <>
                <DropDownSection>
                  <List
                    onClick={() => {
                      navigate("/nftMarket");
                      setDropdown(!dropdown);
                      setShowNavigation(!showNavigation);
                    }}
                  >
                    Home
                  </List>
                  <List
                    onClick={() => {
                      navigate(
                        "/nftcategories/0x7eb272ac9b9fec60c5a7921ccc075152a961111c"
                      );
                      setDropdown(!dropdown);
                      setShowNavigation(!showNavigation);
                    }}
                  >
                    Character
                  </List>
                  <List
                    onClick={() => {
                      navigate(
                        "/nftcategories/0x8fc3dec6148a9924870f205617c9c26b3010243e"
                      );
                      setDropdown(!dropdown);
                      setShowNavigation(!showNavigation);
                    }}
                  >
                    Shootable
                  </List>
                  <List
                    onClick={() => {
                      navigate(
                        "/nftcategories/0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532"
                      );
                      setDropdown(!dropdown);
                      setShowNavigation(!showNavigation);
                    }}
                  >
                    Melee
                  </List>
                  {/* <List
                    onClick={() => {
                      navigate("/auctionnfts");
                      setDropdown(!dropdown);
                      setShowNavigation(!showNavigation);
                    }}
                  >
                   Characters
                  </List> */}
                  {/* <List
                    onClick={() => {
                      navigate("/auctionnfts");
                      setDropdown(!dropdown);
                      setShowNavigation(!showNavigation);
                    }}
                  >
                   Vehicles 
                  </List> */}
                  {/* <List
                    onClick={() => {
                      navigate("/auctionnfts");
                      setDropdown(!dropdown);
                      setShowNavigation(!showNavigation);
                    }}
                  >
                   Auctions 
                  </List> */}
                  {allContractDetails?.address && (
                    <List
                      onClick={() => {
                        navigate("/mynfts");
                        setDropdown(!dropdown);
                        setShowNavigation(!showNavigation);
                      }}
                    >
                      My NFTs 
                    </List>
                  )}
                </DropDownSection>
              </>
            )}
          </MobileIconWrapper>

          {/* <MobileIconWrapper selected={location.pathname === '/metaDao'} 
       onClick={() => {
        navigate(`${Routes.METADAO}`);
        setNavLink('/metaDao');
        setShowNavigation(!showNavigation);
      }}>
      <MobileIcon src={MetaDaoIcon} width="24px" height="20px" /> <TextWraper>MetaDAO</TextWraper>
      </MobileIconWrapper> */}
          {/* <MobileIconWrapper selected={location.pathname === '/stats'} 
       onClick={() => {
        navigate(`${Routes.STATS}`);
        setNavLink('/stats');
        setShowNavigation(!showNavigation);
      }}>
      <MobileIcon src={StatsIcon} width="24px" height="24px" /><TextWraper>Stats</TextWraper>
      </MobileIconWrapper> */}
        </MobileView>
      )}
      <DialogStyledUpdate
        open={buyTokenLoginPopUp}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { overflow: "initial", backgroundColor: "transparent" },
        }}
      >
        {/* <ButtonCancel color="primary">X</ButtonCancel> */}
        <div className={classes.customButton}>
          <NftNameConfirm>
            <NftNameConfirmHead>
             Please Login to Continue
            </NftNameConfirmHead>
            <NftNameConfirmSubHead>
            Please login with same Email Id & provider to keep your assets synced!
            </NftNameConfirmSubHead>
            <BuyPop onClick={()=>handleLogin()}>Login</BuyPop>
          </NftNameConfirm>
        </div>
      </DialogStyledUpdate>
      {balanceLoading==true?<LoginLoader/>:<></>}
    </>
  );
};

export default LeftsideBar;
